<mic-alert-center position="bottom left" />
<div class="flex flex-row h-full mic-login">
  <div class="flex flex-col justify-center items-center h-full grow-1 gap-5">
    <div class="flex flex-row justify-center">
      <p class="text-3xl app-name"><span class="app-name-principal">CAR</span>DEALER</p>
    </div>
    <div class="flex flex-col md-w-5on12 sm-w-8on12 justify-center gap-2" [formGroup]="loginForm">
      <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
        <p>Fazer Login</p>
        <mat-form-field class="w-full">
          <mat-label>Usuário</mat-label>
          <input matInput type="text" required autocomplete="username" formControlName="username" (keydown.enter)="login()" />
        </mat-form-field>
        <mat-form-field class="w-full">
          <mat-label>Senha</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'" required autocomplete="current-password" formControlName="password" (keydown.enter)="login()" />
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
            <mat-icon role="img" [attr.aria-label]="hide ? 'Hide password' : 'Show password'" aria-hidden="false">{{
              hide ? 'visibility_off' : 'visibility'
            }}</mat-icon>
          </button>
        </mat-form-field>
        <div class="flex flex-row justify-between align-center">
          <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="login()">
            <mat-icon>login</mat-icon>
            <span>Login</span>
          </button>
          <mic-link id="mic-forgot-password" label="Recuperar senha" icon="chevron_right" routerLink="/auth/password"></mic-link>
        </div>
      </mic-spinner-overlay>
    </div>
    <div class="flex flex-row items-center justify-center gap-4 mic-login-footer mt-14">
      <p>Powered by</p>
      <mic-logo type="group"></mic-logo>
    </div>
  </div>
  <div class="md-hidden" [ngClass]="{ 'mic-login-trapeze': !image, 'mic-login-image': image, 'w-4on12': !image, 'w-1on2': image }"></div>
</div>
